(() => {
  const initLensColorOptions = (root) => {
    const games = root.querySelectorAll('[data-lens-color-options]');

    games.forEach((game) => {
      if (game.dataset.initialized === 'true') {
        return;
      }

      const panels = Array.from(game.querySelectorAll('[data-color-option-panel]'));
      const triggers = Array.from(game.querySelectorAll('[data-color-option-trigger]'));
      const playButton = game.querySelector('[data-color-play]');
      const interval = Math.max(1000, Number(game.dataset.autoplayInterval) || 3000);
      let activeIndex = Math.max(0, panels.findIndex((panel) => panel.classList.contains('is-active')));
      let autoplay = null;

      if (!panels.length || !triggers.length) {
        return;
      }

      const setPlayMovement = (index) => {
        if (!playButton || panels.length < 2) {
          return;
        }

        const step = index / (panels.length - 1);
        const x = Math.round((step - 0.5) * 44);
        const y = Math.round(Math.sin(step * Math.PI) * -18);

        game.style.setProperty('--play-offset-x', `${x}px`);
        game.style.setProperty('--play-offset-y', `${y}px`);
      };

      const setSelectorProgress = (index) => {
        const progress = panels.length > 0 ? ((index + 0.5) / panels.length) * 100 : 0;

        game.style.setProperty('--selector-progress', `${progress}%`);
      };

      const setActive = (index) => {
        activeIndex = (index + panels.length) % panels.length;

        panels.forEach((panel) => {
          const isActive = Number(panel.dataset.colorIndex) === activeIndex;

          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        triggers.forEach((trigger) => {
          const isActive = Number(trigger.dataset.colorIndex) === activeIndex;

          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        setPlayMovement(activeIndex);
        setSelectorProgress(activeIndex);
      };

      const stopAutoplay = () => {
        if (!autoplay) {
          return;
        }

        window.clearInterval(autoplay);
        autoplay = null;
        game.classList.remove('is-playing');

        if (playButton) {
          playButton.setAttribute('aria-pressed', 'false');
        }
      };

      const startAutoplay = () => {
        if (!playButton || panels.length < 2 || autoplay) {
          return;
        }

        game.classList.add('is-playing');
        playButton.setAttribute('aria-pressed', 'true');
        autoplay = window.setInterval(() => setActive(activeIndex + 1), interval);
        setActive(activeIndex + 1);
      };

      const focusSiblingTrigger = (currentTrigger, index) => {
        const group = currentTrigger.closest('.colors-game__selector__points, .colors-game__list');
        const scopedTriggers = group
          ? Array.from(group.querySelectorAll('[data-color-option-trigger]'))
          : triggers;
        const nextTrigger = scopedTriggers.find((trigger) => Number(trigger.dataset.colorIndex) === index);

        if (nextTrigger) {
          nextTrigger.focus();
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          stopAutoplay();
          setActive(Number(trigger.dataset.colorIndex) || 0);
        });

        trigger.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            return;
          }

          event.preventDefault();
          stopAutoplay();

          let nextIndex = activeIndex;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = activeIndex + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = activeIndex - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = panels.length - 1;
          }

          setActive(nextIndex);
          focusSiblingTrigger(trigger, activeIndex);
        });
      });

      if (playButton) {
        playButton.addEventListener('click', () => {
          if (autoplay) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });
      }

      game.dataset.initialized = 'true';
      game.stopLensColorAutoplay = stopAutoplay;
      setActive(activeIndex);
    });
  };

  const stopLensColorOptions = (root) => {
    root.querySelectorAll('[data-lens-color-options]').forEach((game) => {
      if (typeof game.stopLensColorAutoplay === 'function') {
        game.stopLensColorAutoplay();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initLensColorOptions(document));
  document.addEventListener('shopify:section:load', (event) => initLensColorOptions(event.target));
  document.addEventListener('shopify:section:unload', (event) => stopLensColorOptions(event.target));
})();
